// extracted by mini-css-extract-plugin
module.exports = {"comp":"HighlightsA_comp__2WLuI"};